module.exports = __webpack_public_path__ + "static/img/about_banner.1e41508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about_banner.jpg
// module id = BWQl
// module chunks = 0